// 既存 design/icons.jsx を TSX 化して export

import type { SVGProps, ReactNode } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

const make = (paths: ReactNode, viewBox = "0 0 24 24") => {
  return ({ size = 16, ...rest }: IconProps) => (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {paths}
    </svg>
  );
};

export const Ic = {
  home: make(<><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></>),
  menu: make(<><line x1="4" y1="7" x2="20" y2="7" /><line x1="4" y1="12" x2="20" y2="12" /><line x1="4" y1="17" x2="20" y2="17" /></>),
  dashboard: make(<><rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" /><rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" /></>),
  upload: make(<><path d="M12 3v12" /><path d="M7 8l5-5 5 5" /><path d="M5 17v3a1 1 0 001 1h12a1 1 0 001-1v-3" /></>),
  list: make(<><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><circle cx="4" cy="6" r="1" /><circle cx="4" cy="12" r="1" /><circle cx="4" cy="18" r="1" /></>),
  file: make(<><path d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z" /><path d="M14 3v5h5" /></>),
  users: make(<><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.5 3-6 6-6s6 2.5 6 6" /><circle cx="17" cy="9" r="2.2" /><path d="M21 19c0-2.5-2-4.5-4-4.5" /></>),
  clock: make(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  settings: make(<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 00.4 1.9l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.9-.4 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.6 1.7 1.7 0 00-1.9.4l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.4-1.9 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.6-1.1 1.7 1.7 0 00-.4-1.9l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.9.4H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.9-.4l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.4 1.9V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" /></>),
  search: make(<><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></>),
  chevronR: make(<path d="M9 6l6 6-6 6" />),
  chevronL: make(<path d="M15 6l-6 6 6 6" />),
  chevronD: make(<path d="M6 9l6 6 6-6" />),
  chevronU: make(<path d="M6 15l6-6 6 6" />),
  arrowR: make(<><path d="M5 12h14" /><path d="M13 5l7 7-7 7" /></>),
  plus: make(<><path d="M12 5v14" /><path d="M5 12h14" /></>),
  check: make(<path d="M5 13l4 4L19 7" />),
  checkCircle: make(<><circle cx="12" cy="12" r="9" /><path d="M8 12l3 3 5-6" /></>),
  alert: make(<><path d="M12 9v4" /><path d="M12 17h.01" /><path d="M10.3 3.9L2.6 17.2A2 2 0 004.3 20h15.4a2 2 0 001.7-2.8L13.7 3.9a2 2 0 00-3.4 0z" /></>),
  info: make(<><circle cx="12" cy="12" r="9" /><path d="M12 8h.01" /><path d="M11 12h1v4h1" /></>),
  x: make(<><path d="M6 6l12 12" /><path d="M18 6l-12 12" /></>),
  download: make(<><path d="M12 3v12" /><path d="M7 10l5 5 5-5" /><path d="M5 17v3a1 1 0 001 1h12a1 1 0 001-1v-3" /></>),
  mail: make(<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></>),
  filter: make(<path d="M4 5h16l-6 8v6l-4-2v-4z" />),
  edit: make(<><path d="M4 20h4l10-10-4-4L4 16v4z" /><path d="M14 6l4 4" /></>),
  trash: make(<><path d="M4 7h16" /><path d="M9 7V4h6v3" /><path d="M6 7l1 13h10l1-13" /></>),
  more: make(<><circle cx="6" cy="12" r="1.4" /><circle cx="12" cy="12" r="1.4" /><circle cx="18" cy="12" r="1.4" /></>),
  doc: make(<><path d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z" /><path d="M14 3v5h5" /><line x1="8" y1="13" x2="16" y2="13" /><line x1="8" y1="17" x2="14" y2="17" /></>),
  truck: make(<><rect x="1" y="6" width="13" height="11" rx="1" /><path d="M14 9h4l3 4v4h-7" /><circle cx="6" cy="19" r="2" /><circle cx="17" cy="19" r="2" /></>),
  chart: make(<><path d="M4 20V10" /><path d="M10 20V4" /><path d="M16 20v-7" /><line x1="3" y1="20" x2="21" y2="20" /></>),
  history: make(<><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /><path d="M12 7v5l3 2" /></>),
  yen: make(<><path d="M6 4l6 8 6-8" /><path d="M6 13h12" /><path d="M6 17h12" /><path d="M12 12v8" /></>),
  send: make(<><path d="M22 2L11 13" /><path d="M22 2l-7 20-4-9-9-4z" /></>),
  shield: make(<><path d="M12 3l7 3v6c0 4-3 7.5-7 9-4-1.5-7-5-7-9V6z" /><path d="M9.5 12l1.8 1.8 3.4-3.6" /></>),
  logOut: make(<><path d="M15 17l5-5-5-5" /><path d="M20 12H9" /><path d="M13 3H6a1 1 0 00-1 1v16a1 1 0 001 1h7" /></>),
  key: make(<><circle cx="8" cy="12" r="4" /><path d="M12 12h9" /><path d="M17 12v3" /><path d="M20 12v2" /></>),
};
